<template>
    <div v-loading="loading">
        <layout-headers title='customerTypesTitle' text='customerTypesSubtitle' :redirectButtons="redirectButtons"/>

        <filters :tableData="tableData" v-model="search" @filtered-list="getFilteredList" :fields="['name', 'description']" />
        <br>
        <el-card>
            <el-table :data="filteredData" :empty-text="emptyText">
                <el-table-column
                     sortable
                    prop="name"
                    :label="$t('customerTypesName')">
                </el-table-column>
                <el-table-column
                    sortable
                    :label="$t('customerTypesDescription')">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.description[locale] }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="actions"
                    fixed="right"
                    width="120"
                    :label="$t('tableActions')">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" class="table-button"
                                @click="edit('CustomerTypesEdit', scope.row, 'customerType')"/>
                        <el-button type="danger" icon="el-icon-delete" class="table-button"
                                @click="showModal(scope.row.id)"/>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <modal :config="modalConfig" @closeModal="deleteCustomerType" />
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import LayoutHeaders from '../LayoutPart/LayoutHeaders'
    import Filters from '../Filters/Filter'
    import {getFilteredList, edit} from '@/helpers/helpers'
    import Modal from '../Modal/Modal'
    import {showModal, closeModal} from "../Modal/ModalHelpers"
    import Content from '@/model/resources'
    import '@/assets/vueWysiwyg.css'

    export default {
        components: {
            Modal,
            LayoutHeaders,
            Filters,
        },
        computed: {
            ...mapGetters({
                customerTypes: 'getCustomerTypes',
                authToken: 'getAuthToken',
                locale: 'getLocale'
            }),
        },
        watch: {
            customerTypes () {
                this.tableData = this.customerTypes
                this.loading = false
            }
        },
        created() {
            this.initList()
        },
        data() {
            return {
                redirectButtons: [
                    {
                        path: 'CustomerTypesCreate',
                        param: {
                            isEdit: false,
                            customerType: {
                                name: '',
                                description: {},
                            }
                        },
                        text: 'customerTypesButton'
                    }
                ],
                emptyText: 'Loading...',
                filteredData: undefined,
                id: null,
                loading: true,
                modalConfig: { show: false },
                search: '',
                tableData: [],
                
                
            }
        },
        methods: {
            closeModal,
            edit,
            getFilteredList,
            showModal,
            async initList() {
                await this.$store.dispatch('fetchCustomerTypes')
                .then(() => {
                    this.emptyText = 'No result'
                })
                this.tableData = this.customerTypes
                this.filteredData = this.customerTypes
                
            },
            deleteCustomerType () {
                this.modalConfig.show = false;
                let { id } = this;
                
                if (id) {
                    this.$store.dispatch('deleteCustomerType', id)
                    this.filteredData = this.tableData
                } else {
                    this.showMessage('Id is null')
                }
            },
        }
    }
</script>

<style scoped>
.table-button {
    width: 30px !important; 
    height: 30px !important; 
    padding: 0 !important; 
    margin: 0 !important;
    background: transparent !important;
    color: darkgrey;
    font-size: 20px;
    font-weight: 800;
    border: none;
}

.table-button:hover {
    color: #409EFF !important;
}

</style>



// WEBPACK FOOTER //
// src/components/CustomerTypes/CustomerTypes.vue